import { useCallback, useId, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const useUrlHistorySyncedOpenState = () => {
	const layoutId = useId();
	const navigate = useNavigate();

	const [searchParams, setSearchParams] = useSearchParams();
	const isOpened = useMemo(
		() => searchParams.get('open') === layoutId,
		[searchParams, layoutId],
	);
	const setIsOpened = useCallback(
		(value: boolean) => {
			// Already return if value is not changes
			if (isOpened === value) return;

			if (value) {
				// Set open
				setSearchParams(
					{
						...Object.fromEntries(searchParams.entries()),
						open: layoutId,
					},
					{
						replace: false,
					},
				);
			} else {
				// Go back if url contains open with this layoutId
				const searchParamsString = window.location.search;
				const searchParams = new URLSearchParams(searchParamsString);
				if (searchParams.get('open') === layoutId) navigate(-1);
			}
		},
		[layoutId, navigate, searchParams, setSearchParams],
	);

	return [isOpened, setIsOpened] as const;
};

export default useUrlHistorySyncedOpenState;
